module.exports = __webpack_public_path__ + "static/Bg11b-66a76239993a54cc8845afe2d4dd4eb5.png";